import { MeetingJoinInfo } from "../../../types";

export const annotationColors = [
  "#FF0000", // Bright Red
  "#00BFFF", // Deep Sky Blue
  "#32CD32", // Lime Green
  "#FFD700", // Gold
  "#FF69B4", // Hot Pink
  "#8A2BE2", // Blue Violet
  "#FF8C00", // Dark Orange
  "#00CED1", // Dark Turquoise
  "#000000", // Black
  "#808080", // Gray
];

export const getColorForUser = (
  userId: string,
  joinedInfo: MeetingJoinInfo[],
  defaultIndex: number = -1
): string => {
  const userIndex = joinedInfo?.findIndex(
    (user) => user.userId === userId
  );

  if (userIndex === undefined || userIndex === -1) {
    if (defaultIndex > -1) {
      return annotationColors[defaultIndex % (annotationColors.length - 1)];
    }

    return annotationColors[annotationColors.length - 1];
  }

  if (joinedInfo[userIndex].joinNumber > -1) {
    return annotationColors[joinedInfo[userIndex].joinNumber % (annotationColors.length - 1)];
  }

  return annotationColors[userIndex % (annotationColors.length - 1)];
};
